import { Box, TextField, Tooltip } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { FC } from "react";
import ViewEditTextField from "../view-edit-text-field";

interface ViewEditDatetimeProps {
  props: {
    id: string;
    label: string;
    tooltip?: string;
    initialValue?: string;
    isEdit: boolean;
    format?: string;
    handleInputChange?: (newValue: string, field: string) => void;
  };
}

const ViewEditDatetime: FC<ViewEditDatetimeProps> = ({ props }) => {
  const datetimeFormat = "MM/DD/YYYY HH:mm";
  return (
    <>
      {props.isEdit ? (
        <Box m={1} className="view-edit-box">
          <Tooltip title={props.tooltip ?? ""}>
            {/* Use a react fragment because Tooltip must be given a child that supports refs, and LocalizationProvider does not. */}
            <>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label={props.label}
                  minutesStep={15}
                  inputFormat={datetimeFormat}
                  mask="__/__/____ __:__"
                  value={
                    props.initialValue ? moment(props.initialValue, true) : null //.format(props.format || datetimeFormat) : null
                  }
                  onChange={(newValue) => {
                    if (props.handleInputChange) props.handleInputChange(newValue?.toISOString() || "", props.id);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="dense"
                      fullWidth
                      InputLabelProps={{
                        shrink: props.isEdit || (props.initialValue ? true : false),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </>
          </Tooltip>
        </Box>
      ) : (
        <ViewEditTextField
          props={{
            id: props.id,
            label: props.label,
            initialValue: props.initialValue
              ? moment(props.initialValue, true).format(props.format || datetimeFormat)
              : undefined,
            isEdit: props.isEdit,
            characterLimit: 100,
            handleInputChange: (newValue, field) => {
              if (props.handleInputChange) props.handleInputChange(newValue, field);
            },
          }}
        />
      )}
    </>
  );
};

export default ViewEditDatetime;
